// import title0 from "../assets/images/home/dataUniversePlatform.webp";
import title0 from "../assets/images/home/DU.webp";
import title2 from "../assets/images/home/single.webp";
import title1 from "../assets/images/home/modernize.webp";
import title5 from "../assets/images/home/attended.webp";
import title3 from "../assets/images/home/cloud.webp";
import title4 from "../assets/images/home/ai-ml.webp";
import title6 from "../assets/images/home/crm.webp";
import title7 from "../assets/images/home/cioreview.webp";
import home1stBg from "../assets/images/home/event-slider.webp";
import home4thBg from "../assets/images/home/slider1.webp";

import where_ai_sees_speaks_and_creates from "../assets/images/home/carousel/where_ai_sees_speaks_and_creates.png";
import where_ai_sees_speaks_and_creates_mobile from "../assets/images/home/carousel/mobile/where_ai_sees_speaks_and_creates-mobile.png";
import where_ai_sees_speaks_and_creates_bg from "../assets/images/home/carousel/bg/where_ai_sees_speaks_and_creates-bg.png";

import strategy_that_scales_with_you from "../assets/images/home/carousel/strategy_that_scales_with_you.png";
import strategy_that_scales_with_you_mobile from "../assets/images/home/carousel/mobile/strategy_that_scales_with_you-mobile.png";
import strategy_that_scales_with_you_bg from "../assets/images/home/carousel/bg/strategy_that_scales_with_you-bg.png";

import your_data_trusted_and_ready from "../assets/images/home/carousel/your_data_trusted_and_ready.png";
import your_data_trusted_and_ready_mobile from "../assets/images/home/carousel/mobile/your_data_trusted_and_ready-mobile.png";
import your_data_trusted_and_ready_bg from "../assets/images/home/carousel/bg/your_data_trusted_and_ready-bg.png";

import insights_in_real_time from "../assets/images/home/carousel/insights_in_real_time.png";
import insights_in_real_time_mobile from "../assets/images/home/carousel/mobile/insights_in_real_time-mobile.png";
import insights_in_real_time_bg from "../assets/images/home/carousel/bg/insights_in_real_time-bg.png";

import design_smarter_experiences from "../assets/images/home/carousel/design_smarter_experiences.png";
import design_smarter_experiences_mobile from "../assets/images/home/carousel/mobile/design_smarter_experiences-mobile.png";
import design_smarter_experiences_bg from "../assets/images/home/carousel/bg/design_smarter_experiences-bg.png";

import modernize_legacy_unlock_ai from "../assets/images/home/carousel/modernize_legacy_unlock_ai.png";
import modernize_legacy_unlock_ai_mobile from "../assets/images/home/carousel/mobile/modernize_legacy_unlock_ai-mobile.png";
import modernize_legacy_unlock_ai_bg from "../assets/images/home/carousel/bg/modernize_legacy_unlock_ai-bg.png";

import name_a_top_10_digital_transformation_leader from "../assets/images/home/carousel/name_a_top_10_digital_transformation_leader.png";
import name_a_top_10_digital_transformation_leader_mobile from "../assets/images/home/carousel/mobile/name_a_top_10_digital_transformation_leader-mobile.png";
import name_a_top_10_digital_transformation_leader_bg from "../assets/images/home/carousel/bg/name_a_top_10_digital_transformation_leader-bg.png";

import see_you_at_databricks_summit from "../assets/images/home/carousel/see_you_at_databricks_summit.png";
import see_you_at_databricks_summit_mobile from "../assets/images/home/carousel/mobile/see_you_at_databricks_summit-mobile.png";
import see_you_at_databricks_summit_bg from "../assets/images/home/carousel/bg/see_you_at_databricks_summit-bg.png";

const homePageCarouselData = [
  {
    id: 0,
    title: where_ai_sees_speaks_and_creates,
    title_mob: where_ai_sees_speaks_and_creates_mobile,
    subTitle: "Powering Gen AI agents & workflows",
    bgImage: where_ai_sees_speaks_and_creates_bg,
    redirectionUrl: "",
    link: "/service/enterprise-ai",
    buttonText : "Explore now"
  },
  {
    id: 1,
    title: strategy_that_scales_with_you,
    title_mob: strategy_that_scales_with_you_mobile,
    subTitle: "Future-ready Gen AI and cloud data strategy",
    bgImage: strategy_that_scales_with_you_bg,
    redirectionUrl: "",
    link: "/service/data-strategy",
    buttonText : "Talk to an Expert"
  },
  {
    id: 2,
    title: your_data_trusted_and_ready,
    title_mob: your_data_trusted_and_ready_mobile,
    subTitle: "Modern pipelines and Gen AI-ready governance",
    bgImage: your_data_trusted_and_ready_bg,
    redirectionUrl: "",
    link: "/service/data-management",
    buttonText : "Strengthen Your Data"
  },
  {
    id: 3,
    title: insights_in_real_time,
    title_mob: insights_in_real_time_mobile,
    subTitle: "Dashboards and reporting, powered by AI",
    bgImage: insights_in_real_time_bg,
    redirectionUrl: "",
    link: "/service/data-analytics",
    buttonText : "See It in Action"
  },
  {
    id: 4,
    title: design_smarter_experiences,
    title_mob: design_smarter_experiences_mobile,
    subTitle: "Gen AI-led journeys with omnichannel reach",
    bgImage: design_smarter_experiences_bg,
    redirectionUrl: "",
    link: "/service/customer-experience",
    buttonText : "Transform CX Now"
  },
  {
    id: 5,
    title: modernize_legacy_unlock_ai,
    title_mob: modernize_legacy_unlock_ai_mobile,
    subTitle: "Fast, seamless modernization for Gen AI scale",
    bgImage: modernize_legacy_unlock_ai_bg,
    redirectionUrl: "",
    link: "/service/data-modernization",
    buttonText : "Modernize Your Data"
  },
  {
    id: 6,
    title: name_a_top_10_digital_transformation_leader,
    title_mob: name_a_top_10_digital_transformation_leader_mobile,
    subTitle: "Trusted partners in Data & Digital transformation ",
    bgImage: name_a_top_10_digital_transformation_leader_bg,
    redirectionUrl: "",
    link: "/cio-review",
    buttonText : "Read the Full Feature"
  },
  // {
  //   id: 7,
  //   title: see_you_at_databricks_summit,
  //   title_mob: see_you_at_databricks_summit_mobile,
  //   subTitle: "Gen AI & data innovation – live in booth 505",
  //   bgImage: see_you_at_databricks_summit_bg,
  //   redirectionUrl: "https://resources.nucleusteq.com/databrickssummit2025",
  //   link: "",
  //   buttonText : "Let’s Connect "
  // },
]

export { homePageCarouselData };
